import { safeLinks, smoothScroll } from "./includes/utils.js";
import menu from "./includes/menu.js";
import wrapIframes from "./includes/iframes";
import overlappingImages from "./includes/overlapImages";

const offsets = function () {
  const header = document.querySelector("header.site-header");
  if (header)
    document.documentElement.style.setProperty(
      "--header-offset",
      `${header.offsetHeight}px`
    );

  const eventsHeader = document.querySelector(".event-header .gr-title");
  if (eventsHeader)
    document.documentElement.style.setProperty(
      "--event-header",
      `${eventsHeader.offsetHeight}px`
    );

  const hero = document.querySelector(".swiper.hero .text");
  if (hero)
    document.documentElement.style.setProperty(
      "--hero-header",
      `${hero.offsetHeight}px`
    );
};

document.addEventListener("DOMContentLoaded", (event) => {
  wrapIframes();
  safeLinks();
  smoothScroll();
  offsets();
  menu();
  overlappingImages();
});
